import { ErrorBoundary } from 'react-error-boundary'

import { DeliveryForecast } from '../features/delivery-forecast/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const DeliveryForecastPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <DeliveryForecast />
    </ErrorBoundary>
  )
}
